import React, { Component } from "react";
import Formatter, { flattenLoansByType, sortArrayByKey } from "../../utils/Formatter";
import FinancialTools from "../../utils/FinancialTools";
import { IconButton, Tooltip } from "@mui/material";
import Edit from "@mui/icons-material/Edit";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Dialog from "@mui/material/Dialog";
import DeleteIcon from "@mui/icons-material/Delete";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import LinearProgress from "@mui/material/LinearProgress";
import Validators from "../../utils/Validators";
import { connect } from "react-redux";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { showError, showMessage, confirmAction } from "../../actions/uiActions";
import AccountsApi from "../../api/accounts";
import Icon from "@mui/material/Icon";
import Servicer from "../../forms/Servicer";
import moment from "moment";
import { loanTypes } from '../../constant';
class AllLoans extends Component {
  state = {
    loan: null,
    busy: false,
    newLoan: false,
    adder: true,
    loanTypes: null,
    customServicer: false,
    otherServicers: [],
    editingLoan: null,
    expanded: false,
  };

  toggleExpansion = () => {
    const scrollPosition = window.scrollY; 
    setTimeout(() => window.scrollTo(0, scrollPosition), 0); 
    this.setState({ expanded: !this.state.expanded });
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.otherServicers !== nextProps.data.servicers) {
      return {
        otherServicers: nextProps.data.servicers,
      };
    }
    return null;
  }

  reArrangeLoans(studentLoansState) {
    const studentLoans = [...studentLoansState];
    let foundIndex;
    const studentLoanTypeIndex = studentLoans.findIndex((item) => {
      foundIndex = item.loans.findIndex(
        (subLoan) => subLoan.id === this.state.loan.id
      );
      return foundIndex > -1;
    });
    if (studentLoanTypeIndex > -1) {
      const studentLoanType = studentLoans[studentLoanTypeIndex];
      if (studentLoanType.loan_type !== this.state.loan.loan_type) {
        const subLoan = studentLoanType.loans[foundIndex];
        studentLoanType.loans.splice(foundIndex, 1);
        const newLoanTypeIndex = studentLoans.findIndex(
          (item) => item.loan_type === this.state.loan.loan_type
        );
        if (newLoanTypeIndex === -1) {
          studentLoans.push({
            loan_type: this.state.loan.loan_type,
            total_outstanding_principal: 0,
            total_outstanding_interest: 0,
            loans: [{ ...subLoan, loan_type: this.state.loan.loan_type }],
          });
        } else {
          studentLoans[newLoanTypeIndex].loans.push({
            ...subLoan,
            loan_type: this.state.loan.loan_type,
          });
        }
        if (!studentLoanType.loans.length) {
          // the loan type we removed this from no longer has any loan
          studentLoans.splice(studentLoanTypeIndex, 1);
        }
      }
    }
    return studentLoans;
  }

  save = () => {
    if (
      !Validators.isCurrency(
        this.state.loan.loan_outstanding_principal_balance
      ) &&
      !this.state.loan.loan_outstanding_principal_balance
    )
      this.props.showError(
        "Please enter a valid outstanding principal balance."
      );
    else if (this.state.loan.loan_status.length === 0)
      this.props.showError("Please enter the loan status.");
    else {
      this.setState({ busy: true }, () => {
        let myStudentData = {
          ...this.props.myStudentData,
          student_loans: this.reArrangeLoans(
            this.props.myStudentData.student_loans
          ).map((loan) => {
            loan.total_outstanding_principal = loan.loans.reduce(
              (total, subloan) => {
                if (subloan.id === this.state.loan.id)
                  return (
                    Formatter.moneyToNumber(
                      this.state.loan.loan_outstanding_principal_balance
                    ) + total
                  );
                else
                  return (
                    Formatter.moneyToNumber(
                      subloan.loan_outstanding_principal_balance
                    ) + total
                  );
              },
              0
            );
            loan.total_outstanding_interest = loan.loans.reduce(
              (total, subloan) => {
                if (subloan.id === this.state.loan.id)
                  return (
                    Formatter.moneyToNumber(
                      this.state.loan.loan_outstanding_interest_balance
                    ) + total
                  );
                else
                  return (
                    Formatter.moneyToNumber(
                      subloan.loan_outstanding_interest_balance
                    ) + total
                  );
              },
              0
            );
            loan.loans = loan.loans.map((childLoan) => {
              if (childLoan.loan_amount === 0) {
                childLoan.loan_amount =
                  childLoan.loan_outstanding_principal_balance;
              }
              if (childLoan.id === this.state.loan.id) {
                return {
                  ...this.state.loan,
                  loan_amount:
                    this.state.loan.loan_amount ||
                    childLoan.loan_outstanding_principal_balance,
                };
              }
              return childLoan;
            });
            return loan;
          }),
        };

        AccountsApi.updateMyStudentData(this.props.msdId, myStudentData)
          .then((success) => {
            this.props.onLoanUpdated(myStudentData);
            this.props.showMessage("Loan updated successfully!");
            this.setState({
              busy: false,
              editingLoan: null,
            });
            this.props.confirmAction(
              "The new loan information might impact the strategy found for this user. Would you like to run the analysis again with the new loan information?",
              () => {
                if (
                  !this.props.account.finances ||
                  !this.props.account.finances.agi ||
                  !this.props.account.finances.status ||
                  !this.props.account.employment
                ) {
                  this.props.showError(
                    "You must enter financial and employment details before running analysis."
                  );
                } else {
                  AccountsApi.runAnalysis(this.props.account._id)
                    .then((analysis) => {
                      this.props.onAnalysisUpdated(analysis);
                      this.props.showMessage(
                        "The strategy has been updated to take into consideration the new loan information."
                      );
                      this.setState({ busy: false, editingLoan: null });
                    })
                    .catch((error) => {
                      console.log(error);
                      this.props.showError();
                      this.setState({
                        edit_employment_info: false,
                        busy: false,
                      });
                    });
                }
              },
              "Update Analysis",
              "Run Analysis",
              "Don't Run it",
              () => this.setState({ editingLoan: null, busy: false })
            );
          })
          .catch((error) => {
            console.log(error);
            this.props.showError();
            this.setState({ busy: false });
          });
      });
    }
  };

  modifyLoansToDelete(studentLoansState) {
    const studentLoans = [...studentLoansState];
    let foundIndex;
    const studentLoanTypeIndex = studentLoans.findIndex((item) => {
      foundIndex = item.loans.findIndex((subLoan) => {
        return subLoan.id === this.state.deleteLoanState.id;
      });
      return foundIndex > -1;
    });
    if (studentLoanTypeIndex > -1) {
      const studentLoanType = studentLoans[studentLoanTypeIndex];
      if (studentLoanType.loan_type === this.state.deleteLoanState.loan_type) {
        studentLoanType.loans.splice(foundIndex, 1);
        if (!studentLoanType.loans.length) {
          // the loan type we removed this from no longer has any loan
          studentLoans.splice(studentLoanTypeIndex, 1);
        }
      }
    }
    return studentLoans;
  }

  deleteLoan = (loan) => {
    const deleteLoanState = loan;
    this.setState({ deleteLoanState });
    this.props.confirmAction(
      "This is a irreversible action are you sure you want to delete this loan?",
      () =>
        this.setState({ busy: true }, () => {
          let myStudentData = {
            ...this.props.myStudentData,
            student_loans: this.modifyLoansToDelete(
              this.props.myStudentData.student_loans
            ).map((loan) => {
              loan.total_outstanding_principal = loan.loans.reduce(
                (total, subloan) => {
                  if (subloan.id === this.state.deleteLoanState.id)
                    return (
                      Formatter.moneyToNumber(
                        this.deleteLoanState.loan
                          .loan_outstanding_principal_balance
                      ) + total
                    );
                  else
                    return (
                      Formatter.moneyToNumber(
                        subloan.loan_outstanding_principal_balance
                      ) + total
                    );
                },
                0
              );
              loan.total_outstanding_interest = loan.loans.reduce(
                (total, subloan) => {
                  if (subloan.id === this.state.deleteLoanState.id)
                    return (
                      Formatter.moneyToNumber(
                        this.state.deleteLoanState
                          .loan_outstanding_interest_balance
                      ) + total
                    );
                  else
                    return (
                      Formatter.moneyToNumber(
                        subloan.loan_outstanding_interest_balance
                      ) + total
                    );
                },
                0
              );
              loan.loans = loan.loans.map((childLoan) => {
                if (childLoan.id === this.state.deleteLoanState.id) {
                  return this.state.deleteLoanState;
                }
                return childLoan;
              });
              return loan;
            }),
          };

          AccountsApi.updateMyStudentData(this.props.msdId, myStudentData)
            .then((success) => {
              this.props.onLoanUpdated(myStudentData);
              this.props.showMessage("Loan deleted successfully!");
              if (myStudentData.student_loans.length > 0) {
                this.props.confirmAction(
                  "Because you deleted a loan. The new loan information might impact the strategy found for this user. Would you like to run the analysis again with the new loan information?",
                  () =>
                    AccountsApi.runAnalysis(this.props.account._id)
                      .then((analysis) => {
                        this.props.onAnalysisUpdated(analysis);
                        this.props.showMessage(
                          "The strategy has been updated to take into consideration the new loan information."
                        );
                        this.setState({ busy: false, loan: null });
                      })
                      .catch((error) => {
                        console.log(error);
                        this.props.showError();
                        this.setState({
                          edit_employment_info: false,
                          busy: false,
                        });
                      }),
                  "Update Analysis",
                  "Run Analysis",
                  "Don't Run it",
                  () => this.setState({ loan: null, busy: false })
                );
              } else {
                AccountsApi.runAnalysis(this.props.account._id)
                  .then((analysis) => {
                    this.props.onAnalysisUpdated(analysis);
                    this.setState({ busy: false, loan: null });
                  })
                  .catch((error) => {
                    this.props.showError();
                    this.setState({
                      edit_employment_info: false,
                      busy: false,
                    });
                  });
              }
            })
            .catch((error) => {
              this.props.showError();
              this.setState({ busy: false });
            });
        }),
      "Delete User Loan",
      "Delete Loan",
      "Don't Delete it",
      () => this.setState({ loan: null, busy: false })
    );
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  updateMSDRunAnalysisApi = (myStudentData) => {
    AccountsApi.updateMyStudentData(this.props.msdId, myStudentData)
      .then((success) => {
        this.props.onLoanUpdated(myStudentData);
        this.setState({
          studentLoans: myStudentData.student_loans,
          principalBalance: "",
          interestBalance: "",
          loanType: "",
          mmp: "",
          repaymentPlanType: "",
          servicerName: "",
          servicerAddress: "",
          planBeginDate: "",
          pslfMonths: "",
          loanStatus: "",
          adder: !this.state.adder,
          newLoan: !this.state.newLoan,
        });
        this.props.showMessage("Loan updated successfully!");
        this.props.confirmAction(
          "The new loan information might impact the strategy found for this user. Would you like to run the analysis again with the new loan information?",
          () => {
            if (
              !this.props.account.finances ||
              !this.props.account.finances.agi ||
              !this.props.account.finances.status ||
              !this.props.account.employment
            ) {
              this.props.showError(
                "You must enter financial and employment details before running analysis."
              );
              this.setState({
                edit_employment_info: false,
                busy: false,
                loan: null,
              });
            } else {
              AccountsApi.runAnalysis(this.props.account._id)
                .then(
                  (analysis) => {
                    this.props.onAnalysisUpdated(analysis);
                    this.props.showMessage(
                      "The strategy has been updated to take into consideration the new loan information."
                    );
                    this.setState({ busy: false, loan: null });
                  },
                  (error) => {
                    this.props.showError();
                    this.setState({ loan: null, busy: false });
                  }
                )
                .catch((error) => {
                  this.props.showError();
                  this.setState({
                    edit_employment_info: false,
                    busy: false,
                  });
                });
            }
          },
          "Update Analysis",
          "Run Analysis",
          "Don't Run it",
          () => this.setState({ loan: null, busy: false })
        );
      })
      .catch((error) => {
        this.props.showError();
        this.setState({ busy: false });
      });
  };

  getServicer = (loan) => {
    let servicer = loan.loan_contact;
    return servicer
      ? {
          name: servicer.loan_contact_name,
          address: `${servicer.loan_contact_address1}${
            servicer.loan_contact_address2
              ? ` ${servicer.loan_contact_address2}`
              : ""
          }, ${servicer.loan_contact_city} ${servicer.loan_contact_state}`,
        }
      : { name: "Unknown", address: "Unknown" };
  };

  addLoanButton = (arr, indexLoanType, index) => {
    const loanTypePosition = arr.indexOf(arr[arr.length - 1]);

    let loansPosition;
    arr.map((loanType) => {
      loansPosition = loanType.loans.indexOf(
        loanType.loans[loanType.loans.length - 1]
      );
      return loansPosition;
    });

    // Put button in the last item of the array
    if (indexLoanType === loanTypePosition) {
      if (index === loansPosition) {
        return (
          <div className="row">
            <Tooltip title="Add Loan">
              <IconButton onClick={this.addNewLoan}>
                <Icon>add_circle</Icon>
              </IconButton>
            </Tooltip>
          </div>
        );
      }
    }
  };

  addNewLoan = () => {
    this.setState({
      newLoan: !this.state.newLoan,
      adder: !this.state.adder,
    });
  };

  findLoanIndex = (loanType) => {
    const loanIndex = this.props.myStudentData.student_loans.findIndex(
      (loan) => {
        return loan.loan_type === loanType;
      }
    );
    return loanIndex;
  };

  saveNewLoan = () => {
    if (!this.state.principalBalance) {
      this.props.showError(
        "Please enter a valid outstanding principal balance."
      );
    } else if (!this.state.loanStatus) {
      this.props.showError("Please enter a loan status.");
    } else if (!this.state.repaymentPlanType) {
      this.props.showError("Please enter a Repayment Plan type.");
    } else if (!this.state.loanType) {
      this.props.showError("Please enter a loan a type.");
    } else {
      if (this.findLoanIndex(this.state.loanType) > -1) {
        let pastYear = moment()
          .subtract(1, "year")
          .format("MM/DD/YYYY");

        const existingLoan = this.props.myStudentData.student_loans[
          this.findLoanIndex(this.state.loanType)
        ];

        existingLoan.total_outstanding_principal = `${parseFloat(
          Formatter.moneyToNumber(existingLoan.total_outstanding_principal)
        ) + parseFloat(this.state.principalBalance)}`;

        existingLoan.total_outstanding_interest = `${parseFloat(
          Formatter.moneyToNumber(existingLoan.total_outstanding_interest)
        ) + parseFloat(this.state.interestBalance)}`;

        existingLoan.loans.push({
          isArtificial: true,
          id: Date.now(),
          loan_id: Date.now(),
          school_name: "UNKNOWN",
          school_opeid: "UNKNOWN",
          loan_date: "UNKNOWN",
          repayment_begin_date: pastYear,
          loan_period_begin_date: pastYear,
          loan_period_end_date: pastYear,
          loan_amount: this.state.loanAmount,
          loan_outstanding_principal_balance: this.state.principalBalance,
          loan_outstanding_principal_date: pastYear,
          loan_outstanding_interest_balance: this.state.interestBalance,
          loan_outstanding_interest_date: pastYear,
          loan_interest_type: "FIXED",
          loan_interest: this.state.interestRate
            ? `${this.state.interestRate}%`
            : `0%`,
          loan_repayment_plan_type: this.state.repaymentPlanType,
          loan_repayment_plan_begin_date: this.state.planBeginDate,
          loan_repayment_plan_scheduled_amount: parseFloat(this.state.mmp),
          loan_repayment_idr_anniversary: "",
          loan_confirmed_subsidy_status: "",
          loan_subsidized_usage_in_years: "",
          loan_reaffirmation_date: "",
          loan_most_recent_payment_effective_date: pastYear,
          loan_next_payment_due_date: pastYear,
          loan_cummulative_amount: "",
          loan_pslf_matched_monts: this.state.pslfMonths,
          loan_status: [
            {
              status: this.state.loanStatus.status,
              description: this.state.loanStatus.description,
              date: this.state.loanStatus.date,
            },
          ],
          loan_disbursement_date: pastYear,
          loan_disbursement_amount: "",
          loan_canceled_amount: "",
          loan_canceled_date: "",
          loan_contact: {
            loan_contact_type: "Current Servicer",
            loan_contact_name: this.state.loanContact
              ? this.state.loanContact.servicerName
              : "",
            loan_contact_address1: this.state.loanContact
              ? this.state.loanContact.servicerAddress
              : "",
            loan_contact_address2: "",
            loan_contact_city: this.state.loanContact
              ? this.state.loanContact.servicerCity
              : "",
            loan_contact_state: this.state.loanContact
              ? this.state.loanContact.servicerState
              : "",
            loan_contact_zip: this.state.loanContact
              ? this.state.loanContact.servicerZip
              : "",
            loan_contact_phone: this.state.loanContact
              ? this.state.loanContact.servicerPhone
              : "",
            loan_contact_extension: "",
            loan_contact_email: this.state.loanContact
              ? this.state.loanContact.servicerEmail
              : "",
            loan_contact_website: "",
          },
          loan_type: this.state.loanType,
        });

        const modifiedStudentLoans = [
          ...this.props.myStudentData.student_loans,
        ].map((loan, index) => {
          if (index !== this.findLoanIndex(this.state.loanType)) {
            return loan;
          } else {
            return existingLoan;
          }
        });

        let myStudentData = {
          ...this.props.myStudentData,
          student_loans: modifiedStudentLoans,
        };

        this.updateMSDRunAnalysisApi(myStudentData);
      } else {
        let pastYear = moment()
          .subtract(1, "year")
          .format("MM/DD/YYYY");

        const newLoanType = {
          loan_type: this.state.loanType,

          total_outstanding_principal: parseFloat(this.state.principalBalance),

          total_outstanding_interest: parseFloat(this.state.interestBalance),

          loans: [
            {
              isArtificial: true,
              id: Date.now(),
              loan_id: Date.now(),
              school_name: "UNKNOWN",
              school_opeid: "UNKNOWN",
              loan_date: "UNKNOWN",
              repayment_begin_date: pastYear,
              loan_period_begin_date: pastYear,
              loan_period_end_date: pastYear,
              loan_amount: this.state.loanAmount,
              loan_outstanding_principal_balance: this.state.principalBalance,
              loan_outstanding_principal_date: pastYear,
              loan_outstanding_interest_balance: this.state.interestBalance,
              loan_outstanding_interest_date: pastYear,
              loan_interest_type: "FIXED",
              loan_interest: this.state.interestRate
                ? `${this.state.interestRate}%`
                : `0%`,
              loan_repayment_plan_type: this.state.repaymentPlanType,
              loan_repayment_plan_begin_date: this.state.planBeginDate,
              loan_repayment_plan_scheduled_amount: parseFloat(this.state.mmp),
              loan_repayment_idr_anniversary: "",
              loan_confirmed_subsidy_status: "",
              loan_subsidized_usage_in_years: "",
              loan_reaffirmation_date: "",
              loan_most_recent_payment_effective_date: pastYear,
              loan_next_payment_due_date: pastYear,
              loan_cummulative_amount: "",
              loan_pslf_matched_monts: this.state.pslfMonths,
              loan_status: [
                {
                  status: this.state.loanStatus.status,
                  description: this.state.loanStatus.description,
                  date: this.state.loanStatus.date,
                },
              ],
              loan_disbursement_date: pastYear,
              loan_disbursement_amount: "",
              loan_canceled_amount: "",
              loan_canceled_date: "",
              loan_contact: {
                loan_contact_type: "Current Servicer",
                loan_contact_name: this.state.loanContact
                  ? this.state.loanContact.servicerName
                  : "",
                loan_contact_address1: this.state.loanContact
                  ? this.state.loanContact.servicerAddress
                  : "",
                loan_contact_address2: "",
                loan_contact_city: this.state.loanContact
                  ? this.state.loanContact.servicerCity
                  : "",
                loan_contact_state: this.state.loanContact
                  ? this.state.loanContact.servicerState
                  : "",
                loan_contact_zip: this.state.loanContact
                  ? this.state.loanContact.servicerZip
                  : "",
                loan_contact_phone: this.state.loanContact
                  ? this.state.loanContact.servicerPhone
                  : "",
                loan_contact_extension: "",
                loan_contact_email: this.state.loanContact
                  ? this.state.loanContact.servicerEmail
                  : "",
                loan_contact_website: "",
              },
              loan_type: this.state.loanType,
            },
          ],
        };
        const combinedLoans = [
          ...this.props.myStudentData.student_loans,
          newLoanType,
        ];

        const myStudentData = {
          ...this.props.myStudentData,
          student_loans: combinedLoans,
        };

        // API to UPDATE LOAN DETAILS HERE
        this.updateMSDRunAnalysisApi(myStudentData);
      }
    }
  };

  getItemValue = (item, e) => {
    return Boolean(Number(e.target.value)) || e.target.value === "0"
      ? Formatter.getLoanServicerMailingAddress(Number(e.target.value))[item]
      : JSON.parse(e.target.value)[item];
  };

  renderNewLoans = () => {
    if (this.state.customServicer) {
      return (
        <Servicer
          onCreated={(id) =>
            this.setState({
              servicer: id,
            })
          }
          onCancel={() => this.setState({ customServicer: false })}
        />
      );
    }
    return (
      <Dialog
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        open={true}
      >
        <DialogTitle id="alert-dialog-title">Add New Loan For User</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Complete the information below in order to add a new loan for the
            user. Once the loan is added, the user's MSD file will be updated.
          </DialogContentText>
          <div className="row">
            <div className="col-12">
              <div className="form-group nice">
                <label>Loan Type:</label>
                <select
                  name="loanType"
                  className="form-control"
                  onChange={this.handleChange}
                >
                  <option value="">Select Loan Type</option>
                  {loanTypes.map(({ value, label }) => (
                    <option value={value} key={value}>{label}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-6">
              <div className="form-group nice">
                <label>Original Loan Amount:</label>
                <input
                  disabled={this.state.busy}
                  type="number"
                  className="form-control text-center"
                  defaultValue={0}
                  onChange={this.handleChange}
                  name="loanAmount"
                />
              </div>
            </div>
            <div className="col-6">
              <div className="form-group nice">
                <label>Outstanding Balance:</label>
                <input
                  disabled={this.state.busy}
                  type="number"
                  className="form-control text-center"
                  value={this.state.principalBalance || 0}
                  onChange={this.handleChange}
                  name="principalBalance"
                />
              </div>
            </div>
            <div className="col-6">
              <div className="form-group nice">
                <label>Outstanding Interest:</label>
                <input
                  disabled={this.state.busy}
                  type="number"
                  className="form-control text-center"
                  defaultValue={0}
                  onChange={this.handleChange}
                  name="interestBalance"
                />
              </div>
            </div>
            <div className="col-6">
              <div className="form-group nice">
                <label>Loan Status:</label>
                <select
                  className="form-control"
                  name="loanStatus"
                  onChange={(e) =>
                    this.setState({
                      loanStatus: {
                        status: Formatter.statusCode(e.target.value),
                        description: Formatter.statusText(e.target.value),
                        date: Date.now(),
                      },
                    })
                  }
                >
                  <option value="">Select Status</option>
                  {[0, 1, 2, 3, 4, 5, 6, 7].map((status) => (
                    <option key={status} value={status}>
                      {Formatter.statusText(status)}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-6">
              <div className="form-group nice">
                <label>Repayment Plan:</label>
                <select
                  className="form-control"
                  name="repaymentPlanType"
                  onChange={(e) =>
                    this.setState({
                      repaymentPlanType: Formatter.repaymentPlanText(
                        e.target.value
                      ),
                    })
                  }
                >
                  <option value="">Select Plan</option>
                  {[0, 1, 2, 3, 4, 5, 6, 7].map((plan) => (
                    <option value={plan} key={plan}>
                      {Formatter.repaymentPlanText(plan)}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-6">
              <div className="form-group nice">
                <label>Min. Monthly Payment:</label>
                <input
                  disabled={this.state.busy}
                  type="number"
                  name="mmp"
                  onChange={this.handleChange}
                  className="form-control text-center"
                  defaultValue={0}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="form-group nice">
                <label>PSLF:</label>
                <input
                  disabled={this.state.busy}
                  type="number"
                  className="form-control text-center"
                  defaultValue={0}
                  onChange={this.handleChange}
                  name="pslfMonths"
                />
              </div>
            </div>
            <div className="col-6">
              <div className="form-group nice">
                <label>Interest Rate:</label>
                <input
                  disabled={this.state.busy}
                  type="number"
                  className="form-control text-center"
                  defaultValue={0}
                  onChange={this.handleChange}
                  name="interestRate"
                />
              </div>
            </div>
            <div className="col-6">
              <div className="form-group nice">
                <label>Select Servicer:</label>
                <select
                  onChange={(e) => {
                    if (e.target.value === "add") {
                      this.setState({ customServicer: true });
                    } else {
                      this.setState({
                        loanContact: {
                          servicerName: this.getItemValue("name", e),
                          servicerAddress: this.getItemValue("address", e),
                          servicerCity: this.getItemValue("city", e),
                          servicerState: this.getItemValue("state", e),
                          servicerZip: this.getItemValue("zip", e),
                          servicerFax: this.getItemValue("fax", e),
                          servicerPhone: this.getItemValue("phone", e),
                          servicerEmail: this.getItemValue("email", e),
                        },
                      });
                    }
                  }}
                  disabled={this.state.busy}
                  className="form-control"
                  name="loanContact"
                >
                  <option value="">Select...</option>
                  {[0, 1, 2, 3, 4, 5, 6, 7, 8].map((plan) => (
                    <option value={plan} key={plan}>
                      {Formatter.getLoanServicerMailingAddress(plan).name}
                    </option>
                  ))}
                  <optgroup label="Other Servicers">
                    {this.state.otherServicers.map((servicer) => (
                      <option
                        key={`custom-servicer-${servicer.id}`}
                        value={JSON.stringify(servicer)}
                      >
                        {servicer.name}
                      </option>
                    ))}
                    <option value="add">Add new Servicer...</option>
                  </optgroup>
                </select>
              </div>
            </div>
            <div className="col-6">
              <div className="form-group nice">
                <label>Repayment Start Date:</label>
                <input
                  disabled={this.state.busy}
                  type="date"
                  className="form-control text-center"
                  value={this.state.planBeginDate}
                  onChange={this.handleChange}
                  name="planBeginDate"
                />
              </div>
            </div>
          </div>
          {this.state.busy && <LinearProgress />}
        </DialogContent>
        {!this.state.busy && (
          <DialogActions>
            <Button
              variant="outlined"
              onClick={this.saveNewLoan}
              color="primary"
              autoFocus
            >
              Save New Loan
            </Button>
            <Button
              onClick={() =>
                this.setState({
                  newLoan: !this.state.newLoan,
                  adder: !this.state.adder,
                })
              }
              color="primary"
            >
              Cancel
            </Button>
          </DialogActions>
        )}
      </Dialog>
    );
  };

  renderEditLoan = () => {
    if (this.state.customServicer) {
      return (
        <Servicer
          onCreated={(id) =>
            this.setState({
              servicer: id,
            })
          }
          onCancel={() => this.setState({ customServicer: false })}
        />
      );
    }
    return (
      <Dialog
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        open={true}
      >
        <DialogTitle id="alert-dialog-title">Edit User</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Complete the information below in order to edit the loan for the
            user. Once the loan is updated, the user's MSD file will be updated.
          </DialogContentText>
          <div className="row">
            <div className="col-12">
              <div className="form-group nice">
                <label>Loan Type:</label>
                <select
                  name="loanType"
                  className="form-control"
                  onChange={(e) =>
                    this.setState({
                      loan: {
                        ...this.state.loan,
                        loan_type: e.target.value,
                      },
                    })
                  }
                  value={this.state.loan.loan_type}
                >
                  <option value="">Select Loan Type</option>
                  <option value="DIRECT STAFFORD UNSUBSIDIZED">
                    DIRECT STAFFORD UNSUBSIDIZED
                  </option>
                  <option value="DIRECT STAFFORD SUBSIDIZED">
                    DIRECT STAFFORD SUBSIDIZED
                  </option>
                  <option value="FFEL STAFFORD SUBSIDIZED">
                    FFEL STAFFORD SUBSIDIZED
                  </option>
                  <option value="FFEL STAFFORD UNSUBSIDIZED">
                    FFEL STAFFORD UNSUBSIDIZED
                  </option>
                  <option value="FEDERAL PERKINS">FEDERAL PERKINS</option>
                  <option value="DIRECT CONSOLIDATED UNSUBSIDIZED">
                    DIRECT CONSOLIDATED UNSUBSIDIZED
                  </option>
                  <option value="DIRECT CONSOLIDATED SUBSIDIZED">
                    DIRECT CONSOLIDATED SUBSIDIZED
                  </option>
                  <option value="DIRECT PLUS GRADUATE">
                    DIRECT PLUS GRADUATE
                  </option>
                  <option value="DIRECT PLUS GRADUATE">
                    DIRECT PARENT PLUS
                  </option>
                  <option value="FFEL CONSOLIDATED">FFEL CONSOLIDATED</option>
                  <option value="(LDS) LOANS FOR DISADVANTAGED STUDENTS">
                    (LDS) LOANS FOR DISADVANTAGED STUDENTS
                  </option>
                  <option value="(HPSL) HEALTH PROFESSIONS STUDENT LOANS">
                    (HPSL) HEALTH PROFESSIONS STUDENT LOANS
                  </option>
                </select>
              </div>
            </div>
            <div className="col-6">
              <div className="form-group nice">
                <label>Original Loan Amount:</label>
                <input
                  disabled={this.state.busy}
                  type="number"
                  className="form-control text-center"
                  value={Math.floor(
                    Formatter.moneyToNumber(this.state.loan.loan_amount)
                  )}
                  onChange={(e) =>
                    this.setState({
                      loan: {
                        ...this.state.loan,
                        loan_amount: `${e.target.value}%`,
                      },
                    })
                  }
                />
              </div>
            </div>
            <div className="col-6">
              <div className="form-group nice">
                <label>Outstanding Balance:</label>
                <input
                  disabled={this.state.busy}
                  type="number"
                  className="form-control text-center"
                  value={Math.floor(
                    Formatter.moneyToNumber(
                      this.state.loan.loan_outstanding_principal_balance
                    )
                  )}
                  onChange={(e) => {
                    if (Validators.isCurrency(e.target.value))
                      this.setState({
                        loan: {
                          ...this.state.loan,
                          loan_outstanding_principal_balance: e.target.value,
                        },
                      });
                  }}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="form-group nice">
                <label>Outstanding Interest:</label>
                <input
                  disabled={this.state.busy}
                  type="number"
                  className="form-control text-center"
                  value={Formatter.moneyToNumber(
                    this.state.loan.loan_outstanding_interest_balance
                  )}
                  onChange={(e) => {
                    if (Validators.isCurrency(e.target.value))
                      this.setState({
                        loan: {
                          ...this.state.loan,
                          loan_outstanding_interest_balance: e.target.value,
                        },
                      });
                  }}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="form-group nice">
                <label>Loan Status:</label>
                <select
                  className="form-control"
                  name="loanStatus"
                  value={Formatter.codeStatus(
                    this.state.loan.loan_status[0].status
                  )}
                  onChange={(e) =>
                    this.setState({
                      loan: {
                        ...this.state.loan,
                        loan_status:
                          this.state.loan.loan_status.length > 1
                            ? [
                                {
                                  status: Formatter.statusCode(e.target.value),
                                  description: Formatter.statusText(
                                    e.target.value
                                  ),
                                  date: Formatter.toStandardDate(
                                    this.state.loan
                                      .loan_repayment_plan_begin_date
                                  ),
                                },
                                ...this.state.loan.loan_status.slice(1),
                              ]
                            : [
                                {
                                  status: Formatter.statusCode(e.target.value),
                                  description: Formatter.statusText(
                                    e.target.value
                                  ),
                                  date: Formatter.toStandardDate(
                                    this.state.loan
                                      .loan_repayment_plan_begin_date
                                  ),
                                },
                              ],
                      },
                    })
                  }
                >
                  <option value="">Select Status</option>
                  {[0, 1, 2, 3, 4, 5, 6, 7].map((status) => (
                    <option key={status} value={status}>
                      {Formatter.statusText(status)}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-6">
              <div className="form-group nice">
                <label>Repayment Plan:</label>
                <select
                  className="form-control"
                  name="repaymentPlanType"
                  value={Formatter.repaymentPlanCode(
                    this.state.loan.loan_repayment_plan_type
                  )}
                  onChange={(e) =>
                    this.setState({
                      loan: {
                        ...this.state.loan,
                        loan_repayment_plan_type: Formatter.repaymentPlanText(
                          e.target.value
                        ),
                      },
                    })
                  }
                >
                  <option value="">Select Plan</option>
                  {[0, 1, 2, 3, 4, 5, 6, 7].map((plan) => (
                    <option value={plan} key={plan}>
                      {Formatter.repaymentPlanText(plan)}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-6">
              <div className="form-group nice">
                <label>Min. Monthly Payment:</label>
                <input
                  disabled={this.state.busy}
                  type="number"
                  name="mmp"
                  className="form-control text-center"
                  value={Math.floor(
                    Formatter.moneyToNumber(
                      this.state.loan.loan_repayment_plan_scheduled_amount
                    )
                  )}
                  onChange={(e) => {
                    if (Validators.isCurrency(e.target.value))
                      this.setState({
                        loan: {
                          ...this.state.loan,
                          loan_repayment_plan_scheduled_amount: e.target.value,
                        },
                      });
                  }}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="form-group nice">
                <label>PSLF:</label>
                <input
                  disabled={this.state.busy}
                  type="number"
                  className="form-control text-center"
                  value={this.state.loan.loan_pslf_matched_monts}
                  onChange={(e) =>
                    this.setState({
                      loan: {
                        ...this.state.loan,
                        loan_pslf_matched_monts: e.target.value,
                      },
                    })
                  }
                />
              </div>
            </div>
            <div className="col-6">
              <div className="form-group nice">
                <label>Interest Rate:</label>
                <input
                  disabled={this.state.busy}
                  type="number"
                  className="form-control text-center"
                  defaultValue={Formatter.moneyToNumber(
                    this.state.loan.loan_interest
                  )}
                  onChange={(e) =>
                    this.setState({
                      loan: {
                        ...this.state.loan,
                        loan_interest: `${e.target.value}%`,
                      },
                    })
                  }
                  name="interestRate"
                />
              </div>
            </div>
            <div className="col-6">
              <div className="form-group nice">
                <label>Select Servicer:</label>
                <select
                  className="form-control"
                  value={Formatter.getLoanServicerMailingAddress(
                    this.state.loan.loan_contact.loan_contact_name
                  )}
                  onChange={(e) => {
                    if (e.target.value === "add") {
                      this.setState({
                        customServicer: true,
                      });
                    } else {
                      this.setState({
                        loan: {
                          ...this.state.loan,
                          loan_contact: {
                            loan_contact_type: "Current Servicer",
                            loan_contact_name: this.getItemValue("name", e),
                            loan_contact_address1: this.getItemValue(
                              "address",
                              e
                            ),
                            loan_contact_city: this.getItemValue("city", e),
                            loan_contact_state: this.getItemValue("state", e),
                            loan_contact_zip: this.getItemValue("zip", e),
                            loan_contact_phone: this.getItemValue("phone", e),
                            loan_contact_email: this.getItemValue("email", e),
                          },
                        },
                      });
                    }
                  }}
                >
                  <option value="">Select...</option>
                  {[0, 1, 2, 3, 4, 5, 6, 7, 8].map((servicer) => (
                    <option key={servicer} value={servicer}>
                      {Formatter.getLoanServicerMailingAddress(servicer).name}
                    </option>
                  ))}
                  <optgroup label="Other Servicers">
                    {this.state.otherServicers.map((servicer) => (
                      <option
                        key={`custom-servicer-${servicer.id}`}
                        value={JSON.stringify(servicer)}
                      >
                        {servicer.name}
                      </option>
                    ))}
                    <option value="add">Add new Servicer...</option>
                  </optgroup>
                </select>
              </div>
            </div>
            <div className="col-6">
              <div className="form-group nice">
                <label>Repayment Start Date:</label>
                <input
                  disabled={this.state.busy}
                  type="date"
                  className="form-control text-center"
                  value={Formatter.toInputDate(
                    this.state.loan.loan_repayment_plan_begin_date
                  )}
                  onChange={(e) => {
                    if (Validators.isDateInput(e.target.value))
                      this.setState({
                        loan: {
                          ...this.state.loan,
                          loan_repayment_plan_begin_date: Formatter.toStandardDate(
                            e.target.value
                          ),
                        },
                      });
                  }}
                />
              </div>
            </div>
          </div>
          {this.state.busy && <LinearProgress />}
        </DialogContent>
        {!this.state.busy && (
          <DialogActions>
            <Button
              variant="outlined"
              onClick={this.save}
              color="primary"
              autoFocus
            >
              Update Loan
            </Button>
            <Button
              onClick={() => this.setState({ editingLoan: null })}
              color="primary"
            >
              Cancel
            </Button>
          </DialogActions>
        )}
      </Dialog>
    );
  };

  getLoanStats() {
    let loansInDefault = 0;
    let loansInForbearance = 0;
    let totalLoans = 0;
    let totalParentPlusLoans = 0;
    this.props.myStudentData.student_loans.forEach((eachLoan) => {
      eachLoan.loans.forEach((loan) => {
        if (eachLoan.loan_type.toLowerCase().includes("parent")) {
          totalParentPlusLoans++;
        }
        if (Formatter.moneyToNumber(loan.loan_outstanding_principal_balance)) {
          totalLoans++;
        }
        if (loan.loan_status[0].status === "FB") {
          loansInForbearance++;
        }
        if (
          ((loan.loan_status[0].status || "").startsWith("D") ||
            loan.loan_status[0].status === "XD") &&
          loan.loan_status[0].status !== "DA" &&
          Formatter.moneyToNumber(loan.loan_outstanding_principal_balance)
        ) {
          loansInDefault++;
        }
      });
    });
    return (
      <>
        Total loans: {totalLoans}; In Forbearance: {loansInForbearance}; In Default:{" "}
        {loansInDefault};{" "}
        {totalParentPlusLoans ? (
          <span className="orange-color">
            Total Parent Plus Loan: {totalParentPlusLoans}
          </span>
        ) : (
          <></>
        )}
      </>
    );
  }

  render() {
    if (this.state.customServicer) {
      return (
        <Servicer
          onCreated={(id) =>
            this.setState({
              servicer: id,
            })
          }
          onCancel={() => this.setState({ customServicer: false })}
        />
      );
    }
    return (
      <div className="animated fadeIn">
        <div className="row">
          <div className="col-12">
            <Paper>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>{this.getLoanStats()}</TableCell>
                    <TableCell colSpan={2}>
                      Outstanding Balance: $
                      {Formatter.money(
                        this.props.myStudentData.student_loans.reduce(
                          (total, loan) =>
                            total +
                            Formatter.moneyToNumber(
                              loan.total_outstanding_principal
                            ),
                          0
                        )
                      )}
                    </TableCell>
                    <TableCell colSpan={2}>
                      Outstanding Interest: $
                      {Formatter.money(
                        this.props.myStudentData.student_loans.reduce(
                          (total, loan) =>
                            total +
                            Formatter.moneyToNumber(
                              loan.total_outstanding_interest
                            ),
                          0
                        )
                      )}
                    </TableCell>
                    <TableCell colSpan={2}>
                      MMP: $
                      {Formatter.money(
                        this.props.myStudentData.student_loans.reduce(
                          (total, loan) =>
                            total +
                            loan.loans.reduce((total, loanInfo) => {
                              let loanData = FinancialTools.parseLoan(loanInfo);

                              if (loanData.repayment)
                                return total + loanData.mmp;
                              else return total;
                            }, 0),
                          0
                        )
                      )}
                    </TableCell>
                    <TableCell colSpan={2}>
                      Weighted Interest Rate:{" "}
                      {FinancialTools.getWeightedInterestRate(
                        this.props.myStudentData.student_loans.reduce(
                          (loans, loan) =>
                            loans.concat(
                              loan.loans.filter(
                                (loanInfo) =>
                                  Formatter.moneyToNumber(
                                    loanInfo.loan_outstanding_principal_balance
                                  ) > 0
                              )
                            ),
                          []
                        )
                      )}
                      %
                    </TableCell>
                    <TableCell onClick={this.toggleExpansion}>
                      <NavigateNextIcon
                        className={`navigate-next ${
                          this.state.expanded ? "opened" : ""
                        }`}
                      />
                    </TableCell>
                  </TableRow>
                </TableHead>
              </Table>
              <Table style={{ width: "100%" }}>
                <TableHead>
                  <TableRow>
                    <TableCell className="width10pct">
                      Outstanding Balance
                    </TableCell>
                    <TableCell className="width10pct">
                      Outstanding Interest
                    </TableCell>
                    <TableCell className="width10pct">
                      Min. Monthly Payment
                    </TableCell>
                    <TableCell className="width15pct paddingless">
                      Loan Status
                    </TableCell>
                    <TableCell className="width15pct paddingless">
                      Repayment Plan
                    </TableCell>
                    <TableCell className="width10pct">
                      Repayment Start
                    </TableCell>
                    <TableCell className="width5pct text-center">
                      PSLF
                    </TableCell>
                    <TableCell className="width5pct text-center">
                      Rate
                    </TableCell>
                    {this.props.canEdit && (
                      <TableCell className="width15pct text-center">
                        Options
                      </TableCell>
                    )}
                  </TableRow>
                </TableHead>
                {this.state.expanded && (
                  <TableBody>
                    {sortArrayByKey(flattenLoansByType(this.props.myStudentData), "loan_outstanding_principal_balance")
                      .map((loan, index) => [
                          <TableRow key={index}>
                            <TableCell>
                              {`$${Formatter.money(
                                Formatter.moneyToNumber(
                                  loan.loan_outstanding_principal_balance
                                )
                              )}`}
                            </TableCell>
                            <TableCell>
                              {`$${Formatter.money(
                                Formatter.moneyToNumber(
                                  loan.loan_outstanding_interest_balance
                                )
                              )}`}
                            </TableCell>
                            <TableCell>
                              {`$${Formatter.money(
                                Formatter.moneyToNumber(
                                  loan.loan_repayment_plan_scheduled_amount
                                )
                              )}`}
                            </TableCell>
                            <TableCell className="paddingless">
                              {loan.loan_status.length > 0
                                ? loan.loan_status[0].description
                                : "Unknown"}
                            </TableCell>
                            <TableCell className="paddingless">
                              {loan.loan_repayment_plan_type}
                            </TableCell>
                            <TableCell>{loan.repayment_begin_date}</TableCell>
                            <TableCell className="text-center">
                              {loan.loan_pslf_matched_monts || 0}
                            </TableCell>
                            <TableCell className="text-center">
                              {loan.loan_interest}
                            </TableCell>
                            {this.props.canEdit && (
                              <TableCell className="text-center">
                                <div>
                                  <div className="row">
                                    <Tooltip title="Edit Loan">
                                      <IconButton
                                        onClick={() =>
                                          this.setState({
                                            editingLoan: loan.loan_id,
                                            loan: {
                                              ...loan,
                                              loan_type: loan.loan_type,
                                            },
                                          })
                                        }
                                      >
                                        <Edit />
                                      </IconButton>
                                    </Tooltip>
                                    {loan.isArtificial && (
                                      <Tooltip title="Delete Loan">
                                        <IconButton
                                          onClick={(e) => this.deleteLoan(loan)}
                                        >
                                          <DeleteIcon />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                  </div>
                                </div>
                              </TableCell>
                            )}
                            {this.state.editingLoan === loan.loan_id &&
                              this.renderEditLoan()}
                          </TableRow>,
                          <TableRow>
                            <TableCell className="servicer-line" colSpan={12}>
                              <span className="margin-rigth20px">
                                {" "}
                                <b>Loan Type:</b> {loan.loan_type}
                              </span>{" "}
                              <span className="margin-rigth20px">
                                <span>
                                  <b>Servicer name: </b>{" "}
                                  {this.getServicer(loan).name}{" "}
                                </span>
                              </span>
                            </TableCell>
                          </TableRow>,
                        ])
                    }
                    {this.state.adder && (
                      <Button
                        variant="outlined"
                        onClick={this.addNewLoan}
                        color="primary"
                        autoFocus
                        className="form-control"
                        style={{ margin: 20 }}
                      >
                        Add New Loan
                      </Button>
                    )}
                    {this.state.newLoan && this.renderNewLoans()}
                  </TableBody>
                )}
              </Table>
            </Paper>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return state;
};
export default connect(
  mapStateToProps,
  {
    showError,
    showMessage,
    confirmAction,
  }
)(AllLoans);
